import { GzTabGroupWebComponent } from './component/GzTabGroupWebComponent';
import { WEB_COMPONENT_GZ_TAB_GROUP } from '../../../webcomponents.constants';

export { GzTabGroupWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_TAB_GROUP, GzTabGroupWebComponent);
